import { makeAutoObservable } from "mobx";
import { PurchaseOrderPayloadTracking as PurchaseOrderPayloadTracking } from "../../tracking";
export class PCrossSellingItemProductCardBehaviour {
    constructor(domain) {
        this.type = "ProductCard";
        this.domain = domain;
        makeAutoObservable(this);
    }
    get isActive() {
        return !this.domain.quantity.isZero;
    }
    get quantity() {
        return this.domain.quantity.value;
    }
    increment() {
        this.domain.increment();
    }
    get canDecrement() {
        return !this.domain.quantity.isZero;
    }
    decrement() {
        if (this.canDecrement) {
            this.domain.decrement();
        }
    }
}
export class PCrossSellingItemCartBehaviour {
    constructor(domain) {
        this.type = "Cart";
        this.isActive = false;
        this.domain = domain;
        makeAutoObservable(this);
    }
    add() {
        PurchaseOrderPayloadTracking.collectProductData(this.domain.productInstanceTrackingId, "CartCrossSelling");
        this.domain.add();
    }
}
export const PCrossSellingItemBehaviour = {
    create(domain) {
        switch (domain.type) {
            case "ProductCard":
                return new PCrossSellingItemProductCardBehaviour(domain);
            case "Cart":
                return new PCrossSellingItemCartBehaviour(domain);
        }
    },
};
